import { useEffect, useState } from "react";
import useGoToNavigation from "../../../../util/useGotoNavigation";
import {
    createAccountApi,
    deleteAccountApi,
    detailAccountApi,
    readCrmBusinessUnitListApi,
    readCrmTeamListApi,
    updateAccountApi,
} from "../../../../api/account/AccountApi";
import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { validateStrictEmail } from "../../../../util/emailValiFunc";
import { readAllDutyGroupsApi } from "../../../../api/manage/role/DutyGroupApi";
import { CreateAccountInit } from "./init/CreateAccountInit";
import { CreateAccountInterface } from "./interface/CreateAccountInterface";
import { useModal } from "../../../../hooks";
import { SearchBusinessPartnerInner } from "../../../../components/common/modal/inner/SearchBusinessPartnerInner";
import { RolesSearchInterface } from "../../roles/list/interface/searchInterface";
import { searchInit } from "../../roles/list/init/searchInit";
import AuthorityChecker from "../../../../components/common/authorityGuard/AuthorityChecker";
import { useUser } from "../../../../util/userContext/UserContext";

// 인터페이스 정의
interface RoleListInterface {
    dutyGroupId: number;
    dutyGroupName: string;
    codeRoleId: number;
    codeDutyGroupTypeId: number;
    codeOrgId: number;
    dutyGroupRemark: string;
    groupId: number;
    roleName: string;
    dutyGroupTypeName: string;
    orgName: string;
}

interface TeamListInterface {
    id: string;
    name: string;
}

interface BusinessUnitListInterface {
    id: string;
    name: string;
}

export const AccountCreate = () => {
    const { user } = useUser()
    const { goToNavigation } = useGoToNavigation();
    const [accountParam, setAccountParam] =
        useState<CreateAccountInterface>(CreateAccountInit);
    const { handleModal } = useModal();
    const { id } = useParams<{ id: string }>();
    const [roleList, setRoleList] = useState<RoleListInterface[]>([]);
    const [teamList, setTeamList] = useState<TeamListInterface[]>([]);
    const [businessUnitList, setBusinessUnitList] = useState<
        BusinessUnitListInterface[]
    >([]);

    const formatPhoneNumber = (value: string) => {
        const onlyNumbers = value.replace(/\D/g, "");
        if (onlyNumbers.length <= 3) return onlyNumbers;
        if (onlyNumbers.length <= 6)
            return `${onlyNumbers.slice(0, 3)}-${onlyNumbers.slice(3)}`;
        if (onlyNumbers.length <= 10)
            return `${onlyNumbers.slice(0, 3)}-${onlyNumbers.slice(
                3,
                6
            )}-${onlyNumbers.slice(6)}`;
        return `${onlyNumbers.slice(0, 3)}-${onlyNumbers.slice(
            3,
            7
        )}-${onlyNumbers.slice(7, 11)}`;
    };

    const handleInputChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        const { name, value } = e.target;

        setAccountParam((prevState) => ({
            ...prevState,
            [name]:
                name === "contactNo"
                    ? formatPhoneNumber(value)
                    : name === "phoneNo"
                        ? formatPhoneNumber(value)
                        : value,
        }));
    };

    useEffect(() => {
        console.log(accountParam);
    }, [accountParam]);

    const createAccountApiMutate = useMutation({
        mutationFn: () => createAccountApi(accountParam),
        onSuccess: (res) => {
            if (res.data.code === "0000") {
                handleModal({
                    isOpen: true,
                    contents: "계정이 생성되었습니다.",
                    type: "alert",
                });
                goToNavigation("manage/account/list", "", false);
            } else {
                handleModal({
                    isOpen: true,
                    contents: "서비스 오류가 있습니다.",
                    type: "alert",
                });
                return;
            }
        },
        onError: (res) => {
            alert(res);
        },
    });

    const updateAccountApiMutate = useMutation({
        mutationFn: () => updateAccountApi(accountParam),
        onSuccess: (res) => {
            if (res.data.code === "0000") {
                handleModal({
                    isOpen: true,
                    contents: "회원정보가 수정되었습니다.",
                    type: "alert",
                });
                goToNavigation("manage/account/list", "", false);
            } else {
                handleModal({
                    isOpen: true,
                    contents: "서비스 오류가 있습니다.",
                    type: "alert",
                });
                return;
            }
        },
        onError: (res) => {
            alert(res);
        },
    });

    const detailAccountApiMutate = useMutation({
        mutationFn: () => detailAccountApi({ userId: id }),
        onSuccess: (res) => {
            if (res.data.code === "0000") {
                setAccountParam(res.data.result);
            } else {
            }
        },
        onError: (res) => {
            alert(res);
        },
    });

    const updateAccount = (type: number) => {
        const isEmailVal = validateStrictEmail(accountParam.loginId);

        if (!isEmailVal) {
            handleModal({
                isOpen: true,
                contents: "이메일 형식이 맞지 않습니다.",
                type: "alert",
            });
            return;
        }

        if (type === 1) {
            createAccountApiMutate.mutate();
        } else {
            updateAccountApiMutate.mutate();
            return;
        }
    };

    useEffect(() => {
        if (id) {
            detailAccountApiMutate.mutate();
        }
    }, [id]);

    const deleteItems = () => {
        handleModal({
            isOpen: true,
            contents: "선택된 계정을 삭제하시겠습니까?",
            type: "confirm",
            callback: deleteCallback,
        });
    };

    const deleteCallback = () => {
        let deleteUser = [
            {
                userId: accountParam.userId,
            },
        ];
        deleteAccountApiMutate.mutate(deleteUser);
    };

    const deleteAccountApiMutate = useMutation({
        mutationFn: (data: any) => deleteAccountApi(data),
        onSuccess: (res) => {
            if (res.data.code === "0000") {
                goToNavigation("manage/account/list", "", false);
            } else {
            }
        },
        onError: (res) => {
            alert(res);
        },
    });

    const readAllDutyGroupsApiMutate = useMutation({
        mutationFn: (params: RolesSearchInterface) => readAllDutyGroupsApi(params),
        onSuccess: (res) => {
            if (res.data.code === "0000") {
                setRoleList(res.data.result.userList);
                if (!id) {
                    setAccountParam({
                        ...accountParam,
                        dutyGroupId: res.data.result.userList[0].dutyGroupId,
                    });
                }
            } else {
            }
        },
        onError: (res) => {
            alert(res);
        },
    });

    const readCrmTeamListApiMutate = useMutation({
        mutationFn: () => readCrmTeamListApi(),
        onSuccess: (res) => {
            if (res.data.code === "0000") {
                setTeamList(res.data.result);
            } else {
            }
        },
        onError: (res) => {
            alert(res);
        },
    });

    const readCrmBusinessUnitListApiMutate = useMutation({
        mutationFn: () => readCrmBusinessUnitListApi(),
        onSuccess: (res) => {
            if (res.data.code === "0000") {
                setBusinessUnitList(res.data.result);
            } else {
            }
        },
        onError: (res) => {
            alert(res);
        },
    });

    useEffect(() => {
        readAllDutyGroupsApiMutate.mutate({
            ...searchInit,
            usePagination: false
        });
        readCrmTeamListApiMutate.mutate();
        readCrmBusinessUnitListApiMutate.mutate();
    }, []);

    return (
        <>
            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">
                        {id ? "계정 상세정보" : "계정 생성"}
                    </h3>
                    <div className="filter_toolbar">
                        <button
                            className="btn btn-outline-primary w-100px h-38px"
                            onClick={() => goToNavigation("manage/account/list", "", false)}
                        >
                            <img
                                src={
                                    process.env.PUBLIC_URL +
                                    "/assets/images/icon_hamburger_btn.png"
                                }
                                alt=""
                            />
                            목록
                        </button>
                        <AuthorityChecker authorityNames={['accountWriteYn']}>
                            <>
                                {id ? (
                                    <button
                                        className="btn btn-outline-dark w-100px h-38px"
                                        onClick={() => deleteItems()}
                                    >
                                        <img
                                            src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"}
                                            alt=""
                                        />
                                        선택삭제
                                    </button>
                                ) : (
                                    ""
                                )}
                                <button
                                    className="btn btn-primary w-100px h-38px"
                                    onClick={() => updateAccount(id ? 2 : 1)}
                                >
                                    {id ? "저장" : "생성"}
                                </button>
                            </>
                        </AuthorityChecker>
                    </div>
                </div>
                <h5 className="subheading">기본정보</h5>
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>ID</th>
                            <td className="p-4px" style={{ width: "31.3%" }}>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="loginId"
                                    value={accountParam.loginId}
                                    onChange={handleInputChange}
                                    disabled={!!id}
                                />
                            </td>
                            <th style={{ width: "16.66%" }}>연락처</th>
                            <td className="p-4px">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="contactNo"
                                    value={accountParam.contactNo}
                                    onChange={handleInputChange}
                                    disabled={user?.authority.accountWriteYn === "N"}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>이름</th>
                            <td className="p-4px">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="userName"
                                    value={accountParam.userName}
                                    onChange={handleInputChange}
                                    disabled={user?.authority.accountWriteYn === "N"}
                                />
                            </td>
                            <th>직함</th>
                            <td className="p-4px">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="title"
                                    value={accountParam.title}
                                    onChange={handleInputChange}
                                    disabled={user?.authority.accountWriteYn === "N"}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>회사명</th>
                            <td className="p-4px">
                                <div className="d-flex">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="companyName"
                                        value={accountParam.companyName}
                                        disabled
                                    />
                                    <button
                                        className="btn btn-info btn_search w-100px ms-5px"
                                        onClick={() => {
                                            handleModal({
                                                isOpen: true,
                                                contents: (
                                                    <SearchBusinessPartnerInner
                                                        confirmCallback={(item) => {
                                                            console.log(item);
                                                            setAccountParam({
                                                                ...accountParam,
                                                                companyId: item.accountId,
                                                                companyName: item?.name,
                                                            });
                                                        }}
                                                        modalDepth={1}
                                                    />
                                                ),
                                                type: "",
                                                title: "회사 조회",
                                                modalSize: "xxl",
                                            });
                                        }}
                                        disabled={user?.authority.accountWriteYn === "N"}
                                    >
                                        <img
                                            src={
                                                process.env.PUBLIC_URL +
                                                "/assets/images/icon_search.png"
                                            }
                                            alt=""
                                        />
                                        찾기
                                    </button>
                                </div>
                            </td>
                            <th>회사 이메일</th>
                            <td className="p-4px">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="coEmail"
                                    value={accountParam.coEmail}
                                    onChange={handleInputChange}
                                    disabled={user?.authority.accountWriteYn === "N"}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>부서</th>
                            <td className="p-4px">
                                {accountParam.codeDutyGroupTypeId === 24 || accountParam.dutyGroupTypeName === '외부' ? (
                                    <input
                                        className="form-control"
                                        name="departmentName"
                                        value={accountParam.departmentName || ""}
                                        onChange={handleInputChange}
                                        disabled={user?.authority.accountWriteYn === "N"}
                                    />
                                ) : (
                                    <select
                                        className="form-select"
                                        name="departmentId"
                                        value={accountParam.departmentId || ""}
                                        onChange={handleInputChange}
                                        disabled={user?.authority.accountWriteYn === "N"}
                                    >
                                        {businessUnitList.map(
                                            (el: { id: string; name: string }) => (
                                                <option key={el.id} value={el.id}>
                                                    {el.name}
                                                </option>
                                            )
                                        )}
                                    </select>
                                )}
                            </td>
                            <th>팀</th>
                            <td className="p-4px">
                                {accountParam.codeDutyGroupTypeId === 24 || accountParam.dutyGroupTypeName === '외부' ? (
                                    <input
                                        className="form-control"
                                        name="teamName"
                                        value={accountParam.teamName || ""}
                                        onChange={handleInputChange}
                                        disabled={user?.authority.accountWriteYn === "N"}
                                    />
                                ) : (
                                    <select
                                        className="form-select"
                                        name="teamId"
                                        value={accountParam.teamId || ""}
                                        onChange={handleInputChange}
                                        disabled={user?.authority.accountWriteYn === "N"}
                                    >
                                        {teamList.map((el: { id: string; name: string }) => (
                                            <option key={el.id} value={el.id}>
                                                {el.name}
                                            </option>
                                        ))}
                                    </select>
                                )}
                            </td>
                        </tr>

                        <tr>
                            <th>근무처 전화</th>
                            <td className="p-4px">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="extensionNo"
                                    value={accountParam.extensionNo}
                                    onChange={handleInputChange}
                                    disabled={user?.authority.accountWriteYn === "N"}
                                />
                            </td>
                            <th>휴대폰</th>
                            <td className="p-4px">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="phoneNo"
                                    value={accountParam.phoneNo}
                                    onChange={handleInputChange}
                                    disabled={user?.authority.accountWriteYn === "N"}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>메모</th>
                            <td colSpan={3} className="p-4px">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="remark"
                                    value={accountParam.remark}
                                    onChange={handleInputChange}
                                    disabled={user?.authority.accountWriteYn === "N"}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>

                <h5 className="subheading">역할정보</h5>
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th style={{ width: "22.64%" }}>역할 ID</th>
                            <td className="p-4px" colSpan={5}>
                                <select
                                    className="form-select w-250px"
                                    name="dutyGroupId"
                                    value={
                                        roleList.find(
                                            (el: { dutyGroupId: number; dutyGroupName: string }) =>
                                                el.dutyGroupId === accountParam.dutyGroupId
                                        )?.dutyGroupId || ""
                                    }
                                    onChange={(e) => {
                                        const value = Number(e.target.value);
                                        if (isNaN(value)) return; // NaN 방지

                                        const selectedRole = roleList.find(
                                            (el: any) => el.dutyGroupId === value
                                        );

                                        setAccountParam((prev) => ({
                                            ...prev,
                                            dutyGroupId: value,
                                            teamId: value === 2 ? "" : prev.teamId,
                                            departmentId: value === 2 ? "" : prev.departmentId,
                                            codeDutyGroupTypeId:
                                                selectedRole?.codeDutyGroupTypeId || 0,
                                        }));
                                    }}
                                    disabled={user?.authority.accountWriteYn === "N"}
                                >
                                    {roleList.map((el: any) => (
                                        <option value={el.dutyGroupId}>{el.dutyGroupName}</option>
                                    ))}
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <th>구분</th>
                            <td className="p-4px" style={{ width: "10.69%" }}>
                                <input
                                    type="text"
                                    className="form-control w-250px"
                                    name="category"
                                    value={
                                        roleList.find(
                                            (el: { dutyGroupId: number; dutyGroupName: string }) =>
                                                el.dutyGroupId === accountParam.dutyGroupId
                                        )?.dutyGroupTypeName
                                    }
                                    onChange={handleInputChange}
                                    disabled={true}
                                />
                            </td>
                            <th style={{ width: "22.64%" }}>조직</th>
                            <td className="p-4px" style={{ width: "10.69%" }}>
                                <input
                                    type="text"
                                    className="form-control w-250px"
                                    name="organization"
                                    value={
                                        roleList.find(
                                            (el: { dutyGroupId: number; dutyGroupName: string }) =>
                                                el.dutyGroupId === accountParam.dutyGroupId
                                        )?.orgName
                                    }
                                    onChange={handleInputChange}
                                    disabled={true}
                                />
                            </td>
                            <th style={{ width: "22.64%" }}>역할</th>
                            <td className="p-4px">
                                <input
                                    type="text"
                                    className="form-control w-250px"
                                    name="role"
                                    value={
                                        roleList.find(
                                            (el: { dutyGroupId: number; dutyGroupName: string }) =>
                                                el.dutyGroupId === accountParam.dutyGroupId
                                        )?.roleName
                                    }
                                    onChange={handleInputChange}
                                    disabled={true}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    );
};
